import { fontStyles } from '@/styles/typography';

import { CheckmarkIcon } from '@/ui/Icons/CheckmarkIcon';
import { InfoIconOutline } from '@/ui/Icons/InfoIconOutline';
import {
  MatchaTooltip,
  MatchaTooltipBottomSheet,
  MatchaTooltipContent,
  MatchaTooltipPopover,
  MatchaTooltipTrigger,
} from '@/ui/MatchaTooltip';

const InfoTooltip = ({
  children,
  className,
  header,
}: {
  children: React.ReactNode;
  className?: string;
  header: string;
}) => (
  <MatchaTooltip delayDuration={0}>
    <MatchaTooltipTrigger>
      <button className="text-token-gray-700 mt-0.5 cursor-default hover:cursor-default">
        <InfoIconOutline />
      </button>
    </MatchaTooltipTrigger>
    <MatchaTooltipContent>{children}</MatchaTooltipContent>
    <MatchaTooltipPopover className={className} sideOffset={5} />
    <MatchaTooltipBottomSheet header={header} />
  </MatchaTooltip>
);

type ItemProps = {
  leftLabel: string;
  tooltipContent: React.ReactNode;
  showCheckmark?: boolean;
  rightContent: React.ReactNode;
  className?: string;
};

export const FixedSettingItem = ({
  leftLabel,
  tooltipContent,
  showCheckmark = true,
  rightContent,
  className,
}: ItemProps) => (
  <div className="flex items-center gap-1.5 justify-between text-token-gray-1600">
    <div className="flex items-center gap-1.5">
      <span className={fontStyles({ variant: 'LABEL_MD' })}>{leftLabel}</span>
      <InfoTooltip header={leftLabel} className={className}>
        {tooltipContent}
      </InfoTooltip>
    </div>
    <div className="flex items-center gap-1.5">
      {showCheckmark && <CheckmarkIcon className="text-token-green-900" />}
      {rightContent}
    </div>
  </div>
);
